import React, { useState, useEffect } from 'react';
import InputField from '../../../../../common/InputField';
import SelectOption from '../../../../../common/SelectOption';
import CommonCheckBox from '../../../../../common/CommonCheckBox';
import { Form, Select, Row, Col } from 'antd';
import TimeRangePicker from '../../../../../common/TimePicker/TimeRangePicker';
import FieldName from '../../../../../common/FieldName';
import InputNumberField from '../../../../../common/InputNumberField';
import { useSelector } from 'react-redux';
import { dailyPricingOptionValidation } from '../../../../../../helper/spaceFormValidation';
// import { days } from '../../../../../common/constants';
import {
  discountNameValidation, discountPercentageValidation,
  minimumBookingPeriod,
  pricePerSeatValidation,
  emptyValidation
} from "../../../../../../helper/FeildValidations";
import { SELECTON_TYPE } from "../../../../../common/constants";

const MonthlyPricingOption = ({ hotdeskIndex, pricingOptionIndex, currency, paymentOptionId, isEdit, values = {}, form }) => {

  const rules = [
    {
      required: true,
      message: 'Please Fill Input Field!',
    },
  ];
  // const months = [0.0, 1.0, 1.5, 2.0, 2.5, 3.0, 3.5, 4.0, 4.5, 5.0, 5.5, 6.0, 6.5, 7.0, 8];
  const months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  const [isFullDayAccess, setFullDayAccess] = useState(values?.access24by7 || false);
  const [timePickers, setTimePickers] = useState([{ beginTime: '3:00 am', endTime: '5:00 pm' }]);
  const [selectedDays, setSelectedDays] = useState(isEdit ? values.pricingOptions?.map(d => d.name) || [] : []);
  const savings = useSelector((state) => state.space?.savings?.data || []);
  const [isDiscountVisible, setDiscountVisible] = useState(isEdit && values.discounts ? true : false);
  const [price, setPrice] = useState(null);
  const [fieldValue,setFieldsValue] = useState(isEdit && values?.refundableDepositAvailability ? true:false);
  const days = useSelector((state)=>state.space?.pricingOptionsArray?.data?.filter(days=> days.chargingType==paymentOptionId)[0]?.pricingOptions || []);
  const [dateSelectionOptions, setDateSelectionOptions] = useState(days);
  useEffect(() => {
    setDateSelectionOptions(dailyPricingOptionValidation(days, selectedDays));
  }, [selectedDays]);

  const deselectItems = (item) => {
    setSelectedDays(selectedDays.filter((i) => i !== item));
  };

  const handleFullDayAccess = (e) => {
    setFullDayAccess(e.target.checked)
    setSelectedDays([]);
  }
  return (
    <>
      <Form.Item name={['events', hotdeskIndex, 'chargings', pricingOptionIndex, 'chargingType']}>
        <FieldName fieldName={'id'} fieldValue={paymentOptionId} />
      </Form.Item>
      <Form.Item name={['events', hotdeskIndex, 'chargings', pricingOptionIndex, 'chargingTypeDesc']}>
        <FieldName fieldName={'name'} fieldValue={"Monthly"} />
      </Form.Item>

      <h3>Monthly</h3>
      {/* <Row>
        <Col offset={8}></Col>
        <Col span={16}>
          <CommonCheckBox
            name={['events', hotdeskIndex, 'chargings', pricingOptionIndex, 'proratedFirstMonth']}
            label={'Price prorated for the first month'}
            handleOnChange={null}
          />
        </Col>
      </Row> */}
      {/* <SelectOption
        isMultiple={false}
        name={['events', hotdeskIndex, 'chargings', pricingOptionIndex, 'minimumBookingPeriod']}
        placeholder={'Month'}
        rules={minimumBookingPeriod}
        label={'Minimum Booking Period (Months)'}
        values={months}
        handleOnSelect={null}
      />
      <SelectOption
        isMultiple={false}
        name={['events', hotdeskIndex, 'chargings', pricingOptionIndex, 'earlyTermination']}
        placeholder={'Month'}
        rules={rules}
        label={'Early Termination Period (Months)'}
        values={months}
        handleOnSelect={null}
      /> */}

      {/* <CommonCheckBox
            name={['events', hotdeskIndex, 'chargings', pricingOptionIndex, 'isDiscountVisible']}
            label={'Discount visible ?'}
            handleOnChange={(e) => setDiscountVisible(e.target.checked)}
      /> */}
      {isDiscountVisible && <>
        <SelectOption
          isMultiple={false}
          name={['events', hotdeskIndex, 'chargings', pricingOptionIndex, 'discounts', 0, 'id']}
          placeholder={'Name'}
          rules={discountNameValidation}
          label={'Discount Name'}
          values={savings}
          handleOnSelect={null}
          labelName={'name'}
          valueName={'id'}
        />

        <SelectOption
          isMultiple={false}
          name={['events', hotdeskIndex, 'chargings', pricingOptionIndex, 'discounts', 0, 'term']}
          placeholder={'Month'}
          rules={rules}
          label={'Discount Applicable (Months)'}
          values={months}
          handleOnSelect={null}
        />

        <InputNumberField
          name={['events', hotdeskIndex, 'chargings', pricingOptionIndex, 'discounts', 0, 'amount']}
          label={'Discount %'}
          rules={discountPercentageValidation}
        />
      </>}

      <Row>
        <Col offset={8}></Col>
        <Col span={16}>
          <CommonCheckBox
            name={['events', hotdeskIndex, 'chargings', pricingOptionIndex, 'access24by7']}
            label={'24/7 Access'}
            handleOnChange={handleFullDayAccess}
            checked={isEdit ? values.access24by7 : false}
          />
        </Col>
      </Row>
      {isFullDayAccess && (<InputField
        name={['events', hotdeskIndex, 'chargings', pricingOptionIndex, 'amount']}
        label={'Price'}
        rules={pricePerSeatValidation}
        handleOnChange={(e) => setPrice(e.target.value)}
      />)}
      {!isFullDayAccess && (
        <SelectOption
          isMultiple={true}
          // name={['WeeklyPricingOption', 'days']}
          placeholder={'Days'}
          rules={rules}
          label={'Days'}
          values={days}
          handleOnSelect={(days) => setSelectedDays([...selectedDays, days])}
          handleOnDeselect={deselectItems}
          value={selectedDays}
        />
      )}
      {!isFullDayAccess &&
        selectedDays.map((day, index) => (
          <>
            <Form.Item
              label={day}
              name={[
                'events',
                hotdeskIndex,
                'chargings',
                pricingOptionIndex,
                'pricingOptions',
                index,
              ]}
            >
              <TimeRangePicker
                key={index}
                pickers={timePickers}
                setTimePicker={setTimePickers}
                index={index}
                day={day}
                currency={currency}
                // seatPrice={price}
                initialValue={isEdit && values?.pricingOptions ? values?.pricingOptions[index] : null}
              />
            </Form.Item>
          </>
        ))}

      <SelectOption
        isMultiple={false}
        name={['events', hotdeskIndex, 'chargings', pricingOptionIndex, 'refundableDepositAvailability']}
        placeholder={'Refundable Security Deposit'}
        label={'Refundable Security Deposit'}
        values={SELECTON_TYPE}
        labelName={'name'}
        valueName={'value'}
        rules={emptyValidation}
        handleOnSelect={setFieldsValue}
      />
      
      {fieldValue ?
        <SelectOption
          isMultiple={false}
          name={['events', hotdeskIndex, 'chargings', pricingOptionIndex, 'refundableDeposit', 'months']}
          placeholder={'Month'}
          rules={[{ required: fieldValue }]}
          label={'Number of months'}
          values={months}
        />
        : null}
    </>
  );
};

export default MonthlyPricingOption;
